export default __webpack_public_path__ + "static/media/1_0050.7a3ccda4.webp";